import { memo, useEffect, useRef, useState } from 'react'
import {
  TransformWrapper,
  TransformComponent,
  ReactZoomPanPinchContentRef,
} from 'react-zoom-pan-pinch'
import { Icon24 } from 'cio-design-library/icons'
import { CloseButton, Container, ExpandButton } from './styles'
import { MAX_ZOOM_LEVEL, MIN_ZOOM_LEVEL, ZOOM_IN_STEP_ON_EXPAND } from './constants'
import { ZoomControls } from './components/ZoomControls/ZoomControls'

type Props = {
  children: React.ReactNode
  onExpandStateChange?: (isExpanded: boolean) => void
}

export const ZoomTools = memo((props: Props) => {
  const { children, onExpandStateChange } = props
  const [isExpanded, setIsExpanded] = useState(false)
  const transformWrapperRef = useRef<ReactZoomPanPinchContentRef>(null)

  useEffect(() => {
    if (!transformWrapperRef.current) return

    if (isExpanded) {
      const { scale } = transformWrapperRef.current.instance.transformState
      transformWrapperRef.current.centerView(scale + ZOOM_IN_STEP_ON_EXPAND)
    } else {
      transformWrapperRef.current.resetTransform()
    }

    onExpandStateChange?.(isExpanded)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpanded])

  return (
    <Container>
      <TransformWrapper
        disabled={!isExpanded}
        ref={transformWrapperRef}
        minScale={MIN_ZOOM_LEVEL}
        maxScale={MAX_ZOOM_LEVEL}
      >
        <TransformComponent>{children}</TransformComponent>
        {!isExpanded && (
          <ExpandButton onClick={() => setIsExpanded(true)}>
            <Icon24.FullSize />
          </ExpandButton>
        )}

        {isExpanded && (
          <>
            <CloseButton onClick={() => setIsExpanded(false)}>
              <Icon24.Close />
            </CloseButton>
            <ZoomControls />
          </>
        )}
      </TransformWrapper>
    </Container>
  )
})
